import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import sendWebSocketMessage from '../../services/WebSocket/sendWebSocketMessage/SendWebSocketMessage';

const TrainingOutOfDate: React.FC = () => {
  const navigate = useNavigate();
  const handleCheckInClick = () => {
    localStorage.removeItem(`checkedIn-${locationIdParam}`);
    localStorage.removeItem(`outOfDate-${locationIdParam}`);
    localStorage.removeItem(`traineeData-${locationIdParam}`);
    localStorage.removeItem(`companyData-${locationIdParam}`);
    localStorage.removeItem(`locationId-${locationIdParam}`);
    navigate(`/checkin/${companyIdParam}/${regionIdParam}/${locationIdParam}`); // Navigate to the test screen
  };
  useEffect(() => {
    sendWebSocketMessage(
      `locationId=${locationIdParam}`,
      `Visitor could not checked in at because training is out of date`,
      'sendMessage'
    );
  });

  const {
    companyId: companyIdParam = '',
    regionId: regionIdParam = '',
    locationId: locationIdParam = '',
  } = useParams<{ companyId: string; regionId: string; locationId: string }>();

  return (
    <div className="tervuren-container__column-center bg-primary mh-100 flex-gap-1">
      <div className="tervuren-container__column-center-75">
        <i
          className="trainee-profile-icon"
          aria-hidden="true"
          style={{ color: '#D25F5E' }}
        />
        <h1 className="fw-500">Training Expired</h1>
        <p className="text-center">
          Please visit the ScaleHouse to update your Site-Specific Hazard
          Awareness Safety Training.
        </p>
        <button
          className="tervuren-button-primary mt-10"
          onClick={handleCheckInClick}
        >
          Return to Check-In
        </button>
      </div>
    </div>
  );
};

export default TrainingOutOfDate;
